// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { bulkDeleteCrmObjectsRequestToJson, createCrmObjectRequestToJson, createCrmObjectResponseFromJson, deleteCrmObjectRequestToJson, getMultiCrmObjectRequestToJson, getMultiCrmObjectResponseFromJson, listCrmObjectsRequestToJson, listCrmObjectsResponseFromJson, listFieldOptionsRequestToJson, listFieldOptionsResponseFromJson, listFiltersRequestToJson, listFiltersResponseFromJson, restoreCrmObjectRequestToJson, startBulkCompanyCreateRequestToJson, startBulkCompanyCreateResponseFromJson, updateCrmObjectRequestToJson, validateCrmObjectRequestToJson, validateCrmObjectResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createCompany(request) {
    const raw = await fetchRpc('crm.v1.CRMCompanyService/CreateCompany', createCrmObjectRequestToJson(request));
    return createCrmObjectResponseFromJson(raw);
}
export function createCompany$(request, options) {
    return defer(() => createCompanyWithTransport$(getGlobalTransport(), request, options));
}
export function createCompanyWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/CreateCompany', createCrmObjectRequestToJson(request), options)
        .pipe(map(resp => createCrmObjectResponseFromJson(resp)));
}
export async function updateCompany(request) {
    await fetchRpc('crm.v1.CRMCompanyService/UpdateCompany', updateCrmObjectRequestToJson(request));
}
export function updateCompany$(request, options) {
    return defer(() => updateCompanyWithTransport$(getGlobalTransport(), request, options));
}
export function updateCompanyWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/UpdateCompany', updateCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getMultiCompany(request) {
    const raw = await fetchRpc('crm.v1.CRMCompanyService/GetMultiCompany', getMultiCrmObjectRequestToJson(request));
    return getMultiCrmObjectResponseFromJson(raw);
}
export function getMultiCompany$(request, options) {
    return defer(() => getMultiCompanyWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiCompanyWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/GetMultiCompany', getMultiCrmObjectRequestToJson(request), options)
        .pipe(map(resp => getMultiCrmObjectResponseFromJson(resp)));
}
export async function listCompanies(request) {
    const raw = await fetchRpc('crm.v1.CRMCompanyService/ListCompanies', listCrmObjectsRequestToJson(request));
    return listCrmObjectsResponseFromJson(raw);
}
export function listCompanies$(request, options) {
    return defer(() => listCompaniesWithTransport$(getGlobalTransport(), request, options));
}
export function listCompaniesWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/ListCompanies', listCrmObjectsRequestToJson(request), options)
        .pipe(map(resp => listCrmObjectsResponseFromJson(resp)));
}
export async function listCompaniesFilters(request) {
    const raw = await fetchRpc('crm.v1.CRMCompanyService/ListCompaniesFilters', listFiltersRequestToJson(request));
    return listFiltersResponseFromJson(raw);
}
export function listCompaniesFilters$(request, options) {
    return defer(() => listCompaniesFiltersWithTransport$(getGlobalTransport(), request, options));
}
export function listCompaniesFiltersWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/ListCompaniesFilters', listFiltersRequestToJson(request), options)
        .pipe(map(resp => listFiltersResponseFromJson(resp)));
}
export async function deleteCompany(request) {
    await fetchRpc('crm.v1.CRMCompanyService/DeleteCompany', deleteCrmObjectRequestToJson(request));
}
export function deleteCompany$(request, options) {
    return defer(() => deleteCompanyWithTransport$(getGlobalTransport(), request, options));
}
export function deleteCompanyWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/DeleteCompany', deleteCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function restoreCompany(request) {
    await fetchRpc('crm.v1.CRMCompanyService/RestoreCompany', restoreCrmObjectRequestToJson(request));
}
export function restoreCompany$(request, options) {
    return defer(() => restoreCompanyWithTransport$(getGlobalTransport(), request, options));
}
export function restoreCompanyWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/RestoreCompany', restoreCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function validateCompany(request) {
    const raw = await fetchRpc('crm.v1.CRMCompanyService/ValidateCompany', validateCrmObjectRequestToJson(request));
    return validateCrmObjectResponseFromJson(raw);
}
export function validateCompany$(request, options) {
    return defer(() => validateCompanyWithTransport$(getGlobalTransport(), request, options));
}
export function validateCompanyWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/ValidateCompany', validateCrmObjectRequestToJson(request), options)
        .pipe(map(resp => validateCrmObjectResponseFromJson(resp)));
}
export async function listCompanyFieldOptions(request) {
    const raw = await fetchRpc('crm.v1.CRMCompanyService/ListCompanyFieldOptions', listFieldOptionsRequestToJson(request));
    return listFieldOptionsResponseFromJson(raw);
}
export function listCompanyFieldOptions$(request, options) {
    return defer(() => listCompanyFieldOptionsWithTransport$(getGlobalTransport(), request, options));
}
export function listCompanyFieldOptionsWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/ListCompanyFieldOptions', listFieldOptionsRequestToJson(request), options)
        .pipe(map(resp => listFieldOptionsResponseFromJson(resp)));
}
export async function startBulkCompanyCreate(request) {
    const raw = await fetchRpc('crm.v1.CRMCompanyService/StartBulkCompanyCreate', startBulkCompanyCreateRequestToJson(request));
    return startBulkCompanyCreateResponseFromJson(raw);
}
export function startBulkCompanyCreate$(request, options) {
    return defer(() => startBulkCompanyCreateWithTransport$(getGlobalTransport(), request, options));
}
export function startBulkCompanyCreateWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/StartBulkCompanyCreate', startBulkCompanyCreateRequestToJson(request), options)
        .pipe(map(resp => startBulkCompanyCreateResponseFromJson(resp)));
}
export async function bulkDeleteCompanies(request) {
    await fetchRpc('crm.v1.CRMCompanyService/BulkDeleteCompanies', bulkDeleteCrmObjectsRequestToJson(request));
}
export function bulkDeleteCompanies$(request, options) {
    return defer(() => bulkDeleteCompaniesWithTransport$(getGlobalTransport(), request, options));
}
export function bulkDeleteCompaniesWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMCompanyService/BulkDeleteCompanies', bulkDeleteCrmObjectsRequestToJson(request), options)
        .pipe(map(() => undefined));
}
